import type { ProductSummaryWithHighlight } from "@/components/ProductSearch/types";
import { formatFlexibility } from "@/utils/functions/formatting";
import normalizeHref from "@/utils/functions/normalizeHref";
import type { CompactProduct } from "../types";

const normalizePartnerName = (name: string | string[] | undefined): string => {
  if (!name) return "";
  return Array.isArray(name) ? name.join(", ") : name;
};

export const convertHitToCompactProduct = (
  hit: ProductSummaryWithHighlight,
): CompactProduct => ({
  productUuid: hit.productUuid,
  productType: hit.productType,
  partnerName: normalizePartnerName(hit.partnerName),
  partnerKeys: hit.partnerKeys,
  partnerLogoUrl:
    hit.partnerLogoOverride ??
    hit.organizationLogoOverride ??
    hit.partnerLogoUrl,
  productName: hit.productName,
  shortDescription: hit.shortDescription ?? "",
  productUrl: normalizeHref(hit?.productSlug || ""),
  flexibility: formatFlexibility(hit.flexibility),
  weeksToComplete: hit.weeksToComplete ?? undefined,
  subjects: hit.attributes ?? undefined,
});
